(function(){
  var s=document.getElementById('marcas'); if(!s) return;
  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  s.querySelectorAll('[data-bs-card]').forEach(function(c){
    c.addEventListener('pointermove',function(e){var r=c.getBoundingClientRect();c.style.setProperty('--mx',(e.clientX-r.left)+'px');c.style.setProperty('--my',(e.clientY-r.top)+'px');});
  });
  var n=s.querySelector('[data-count]');
  function count(){
    if(!n) return;
    var t=parseInt(n.getAttribute('data-count'),10)||0;
    if(rm||!t){n.textContent=t;return;}
    var st=null;
    function f(ts){if(!st)st=ts;var p=Math.min((ts-st)/1600,1);n.textContent=Math.round(t*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(f);}
    n.textContent=0;requestAnimationFrame(f);
  }
  if(!('IntersectionObserver' in window)||(window.Shopify&&window.Shopify.designMode)){count();}
  else{var io=new IntersectionObserver(function(en){if(en[0].isIntersecting){count();io.disconnect();}},{threshold:.2});io.observe(s);}

  /* Carrusel infinito: automatico + flechas + arrastrar/deslizar */
  var stage=s.querySelector('.bs-stage'), vp=s.querySelector('[data-bs-viewport]'), set=s.querySelector('[data-bs-set]');
  if(!stage||!vp||!set||!set.children.length) return;
  var rail=set.parentNode, COPIES=5, i, cl;
  for(i=1;i<COPIES;i++){cl=set.cloneNode(true);cl.removeAttribute('data-bs-set');cl.setAttribute('aria-hidden','true');
    cl.querySelectorAll('a').forEach(function(a){a.setAttribute('tabindex','-1');});rail.appendChild(cl);}
  var duration=parseFloat(stage.getAttribute('data-duration'))||50;
  var W=0,pos=0,userAt=0,hover=false,focusIn=false,paused=false,dragging=false,moved=0,last=null;
  var btnPause=s.querySelector('[data-bs-pause]'),lbl=s.querySelector('[data-bs-pause-label]');
  function measure(){var keep=W?(pos-2*W)/W:0;W=set.offsetWidth;if(!W)return;pos=2*W+keep*W;vp.scrollLeft=pos;}
  function wrap(){if(!W)return;var ch=false;while(pos>=3*W){pos-=W;ch=true;}while(pos<2*W){pos+=W;ch=true;}if(ch)vp.scrollLeft=pos;}
  function touch(){userAt=Date.now();}
  function step(ts){
    if(last===null)last=ts;var dt=Math.min(ts-last,64);last=ts;
    if(W&&!paused&&!hover&&!focusIn&&!dragging&&Date.now()-userAt>2500&&!document.hidden){
      pos+=(2*W/duration)*(dt/1000);wrap();vp.scrollLeft=pos;
    }
    requestAnimationFrame(step);
  }
  vp.addEventListener('scroll',function(){
    if(Math.abs(vp.scrollLeft-pos)>2){pos=vp.scrollLeft;touch();wrap();}
  },{passive:true});
  function go(dir){touch();var c=set.children[0];var w=c?c.offsetWidth+parseFloat(getComputedStyle(c).marginRight||0):340;
    vp.scrollBy({left:dir*w,behavior:'smooth'});}
  s.querySelector('[data-bs-prev]').addEventListener('click',function(){go(-1);});
  s.querySelector('[data-bs-next]').addEventListener('click',function(){go(1);});
  stage.addEventListener('keydown',function(e){
    if(e.key==='ArrowLeft'){e.preventDefault();go(-1);}else if(e.key==='ArrowRight'){e.preventDefault();go(1);}
  });
  vp.addEventListener('pointerdown',function(e){
    touch();if(e.pointerType!=='mouse'||e.button!==0)return;
    dragging=true;moved=0;var sx=e.clientX,sl=vp.scrollLeft;vp.classList.add('is-dragging');
    function mv(ev){var dx=ev.clientX-sx;moved=Math.max(moved,Math.abs(dx));vp.scrollLeft=sl-dx;}
    function up(){dragging=false;vp.classList.remove('is-dragging');touch();window.removeEventListener('pointermove',mv);window.removeEventListener('pointerup',up);window.removeEventListener('pointercancel',up);}
    window.addEventListener('pointermove',mv);window.addEventListener('pointerup',up);window.addEventListener('pointercancel',up);
  });
  vp.addEventListener('click',function(e){if(moved>6){e.preventDefault();e.stopPropagation();moved=0;}},true);
  vp.addEventListener('touchstart',touch,{passive:true});
  vp.addEventListener('wheel',touch,{passive:true});
  stage.addEventListener('mouseenter',function(){hover=true;});
  stage.addEventListener('mouseleave',function(){hover=false;touch();});
  stage.addEventListener('focusin',function(){focusIn=true;});
  stage.addEventListener('focusout',function(){focusIn=false;touch();});
  btnPause.addEventListener('click',function(){
    paused=!paused;btnPause.setAttribute('aria-pressed',paused?'true':'false');lbl.textContent=paused?'Reproducir':'Pausar';
  });
  window.addEventListener('resize',measure);
  window.addEventListener('load',measure);
  measure();requestAnimationFrame(step);
})();